"use strict";

(function (angular) {
  "use strict";

  angular.module("fleetviewApp").service("GroupsService", GroupsService);

  GroupsService.$inject = ["$q", "DriverGroups", "VehicleGroups", "UserProvider"];

  function GroupsService($q, DriverGroups, VehicleGroups, UserProvider) {
    var vehicleGroupPromise = null;
    var driverGroupPromise = null;

    var service = {
      getVehicleGroups: getVehicleGroups,
      getDriverGroups: getDriverGroups
    };

    return service;

    function getVehicleGroups(forceRefresh) {
      if (forceRefresh === true) {
        vehicleGroupPromise = null;
      }

      // don't have the data already but have a promise for it, return that.
      if (vehicleGroupPromise) {
        return vehicleGroupPromise;
      }

      var supportAccountId = null;
      if (UserProvider.getUser().supportAccount) {
        supportAccountId = UserProvider.getUser().supportAccount.accountId;
      }
      vehicleGroupPromise = VehicleGroups.getVehicleGroups([], [], null, null, supportAccountId);

      return vehicleGroupPromise;
    }

    function getDriverGroups(forceRefresh) {
      if (forceRefresh === true) {
        driverGroupPromise = null;
      }

      if (driverGroupPromise) {
        return driverGroupPromise;
      }

      var supportAccountId = null;
      if (UserProvider.getUser().supportAccount) {
        supportAccountId = UserProvider.getUser().supportAccount.accountId;
      }
      driverGroupPromise = DriverGroups.getDriverGroups([], [], null, null, supportAccountId);

      return driverGroupPromise;
    }

    function querystringSettings(settings) {
      console.log(settings);
      return settings;
    }
  }
})(window.angular);


// WEBPACK FOOTER //
// ./app/compliance/groups.service.js